import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;

import { WineListTypes } from "@dp/services";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";
import { computed, makeObservable, observable, runInAction } from "mobx";
export var WineListModel = (_class = /*#__PURE__*/function () {
  //filtering
  function WineListModel() {
    _classCallCheck(this, WineListModel);

    _initializerDefineProperty(this, "_winesObjectForUI", _descriptor, this);

    _initializerDefineProperty(this, "_activeCategory", _descriptor2, this);

    _initializerDefineProperty(this, "_winesList", _descriptor3, this);

    _initializerDefineProperty(this, "_searchText", _descriptor4, this);

    _initializerDefineProperty(this, "_loading", _descriptor5, this);

    _initializerDefineProperty(this, "_subCategoriesList", _descriptor6, this);

    _initializerDefineProperty(this, "_wineResults", _descriptor7, this);

    _initializerDefineProperty(this, "_searchResults", _descriptor8, this);

    _initializerDefineProperty(this, "_filters", _descriptor9, this);

    _initializerDefineProperty(this, "_currentWinesForFilters", _descriptor10, this);

    _initializerDefineProperty(this, "_activeFilterName", _descriptor11, this);

    _initializerDefineProperty(this, "_currentFilters", _descriptor12, this);

    _initializerDefineProperty(this, "_winePairingCodesAndNames", _descriptor13, this);

    _initializerDefineProperty(this, "_sortBy", _descriptor14, this);

    _initializerDefineProperty(this, "_restaurantNumber", _descriptor15, this);

    makeObservable(this);
  }

  _createClass(WineListModel, [{
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                runInAction(function () {
                  _this._searchText = null;
                  _this._searchResults = [];
                  _this._sortBy = null;
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "_decodeCategories",
    value: function _decodeCategories() {
      var _this2 = this;

      if (this.winesObjectForUI) {
        var categories = Object === null || Object === void 0 ? void 0 : Object.keys(this.winesObjectForUI);
        var decodedCategories = categories.map(function (cat) {
          var hasSubCategories;

          if (Array.isArray(_this2.winesObjectForUI[cat])) {
            hasSubCategories = false;
          } else {
            hasSubCategories = true;
          }

          var name = WineListTypes.CATEGORIES[cat].replaceAll("_", " ");
          var code = cat;
          return {
            name: name,
            code: code,
            hasSubCategories: hasSubCategories
          };
        });
        return decodedCategories;
      }

      return [];
    }
  }, {
    key: "_getWineItemString",
    value: function _getWineItemString(item) {
      var name = item.name,
          varietalName = item.varietalName,
          flavorName = item.flavorName,
          countryName = item.countryName,
          regionName = item.regionName,
          vintage = item.vintage,
          subregionName = item.subregionName;
      var wineSearchString = "".concat(name, " ").concat(varietalName, " ").concat(flavorName, " ").concat(countryName, " ").concat(regionName, " ").concat(vintage, " ").concat(subregionName);
      var normalisedWineSearchString = wineSearchString.normalize("NFD").replace(/(?:[\^`\xA8\xAF\xB4\xB7\xB8\u02B0-\u034E\u0350-\u0357\u035D-\u0362\u0374\u0375\u037A\u0384\u0385\u0483-\u0487\u0559\u0591-\u05A1\u05A3-\u05BD\u05BF\u05C1\u05C2\u05C4\u064B-\u0652\u0657\u0658\u06DF\u06E0\u06E5\u06E6\u06EA-\u06EC\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F5\u0818\u0819\u08E3-\u08FE\u093C\u094D\u0951-\u0954\u0971\u09BC\u09CD\u0A3C\u0A4D\u0ABC\u0ACD\u0AFD-\u0AFF\u0B3C\u0B4D\u0B55\u0BCD\u0C4D\u0CBC\u0CCD\u0D3B\u0D3C\u0D4D\u0DCA\u0E47-\u0E4C\u0E4E\u0EBA\u0EC8-\u0ECC\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F82-\u0F84\u0F86\u0F87\u0FC6\u1037\u1039\u103A\u1063\u1064\u1069-\u106D\u1087-\u108D\u108F\u109A\u109B\u135D-\u135F\u17C9-\u17D3\u17DD\u1939-\u193B\u1A75-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B34\u1B44\u1B6B-\u1B73\u1BAA\u1BAB\u1C36\u1C37\u1C78-\u1C7D\u1CD0-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1D2C-\u1D6A\u1DC4-\u1DCF\u1DF5-\u1DF9\u1DFD-\u1DFF\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2CEF-\u2CF1\u2E2F\u302A-\u302F\u3099-\u309C\u30FC\uA66F\uA67C\uA67D\uA67F\uA69C\uA69D\uA6F0\uA6F1\uA700-\uA721\uA788-\uA78A\uA7F8\uA7F9\uA8C4\uA8E0-\uA8F1\uA92B-\uA92E\uA953\uA9B3\uA9C0\uA9E5\uAA7B-\uAA7D\uAABF-\uAAC2\uAAF6\uAB5B-\uAB5F\uAB69-\uAB6B\uABEC\uABED\uFB1E\uFE20-\uFE2F\uFF3E\uFF40\uFF70\uFF9E\uFF9F\uFFE3]|\uD800\uDEE0|\uD802[\uDEE5\uDEE6]|\uD803[\uDD22-\uDD27\uDF46-\uDF50]|\uD804[\uDCB9\uDCBA\uDD33\uDD34\uDD73\uDDC0\uDDCA-\uDDCC\uDE35\uDE36\uDEE9\uDEEA\uDF3C\uDF4D\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC42\uDC46\uDCC2\uDCC3\uDDBF\uDDC0\uDE3F\uDEB6\uDEB7\uDF2B]|\uD806[\uDC39\uDC3A\uDD3D\uDD3E\uDD43\uDDE0\uDE34\uDE47\uDE99]|\uD807[\uDC3F\uDD42\uDD44\uDD45\uDD97]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF8F-\uDF9F\uDFF0\uDFF1]|\uD834[\uDD67-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uD838[\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD46\uDD48-\uDD4A])/g, "").toLowerCase();
      return normalisedWineSearchString;
    }
  }, {
    key: "_filterWinesBySearchText",
    value: function _filterWinesBySearchText() {
      var _this3 = this;

      var filteredWines = this.winesList.wines.filter(function (wine) {
        var wineItemString = _this3._getWineItemString(wine);

        if (wineItemString.indexOf(_this3.searchText.toLowerCase().trim()) !== -1) {
          return true;
        }

        return false;
      });
      this.searchResults = filteredWines;
    }
  }, {
    key: "filterWines",
    value: function filterWines() {
      var _this$searchText;

      if (((_this$searchText = this.searchText) === null || _this$searchText === void 0 ? void 0 : _this$searchText.length) <= 2) {
        this.searchResults = [];
      } else {
        this._filterWinesBySearchText();

        this.sortWines();
      }

      this.loading = false;
    }
  }, {
    key: "getWinesForCategoryWithSubCategories",
    value: function getWinesForCategoryWithSubCategories(currentCategoryObject, activeCategory) {
      var winesForCategoryWithSubCategories = [];
      Object.keys(currentCategoryObject).forEach(function (subCategory) {
        winesForCategoryWithSubCategories.push.apply(winesForCategoryWithSubCategories, _toConsumableArray(currentCategoryObject[subCategory]));
      });

      if (activeCategory === "pairings") {
        return this.removeDuplicatesFromArrayOfObjects(winesForCategoryWithSubCategories, "wineID");
      }

      return winesForCategoryWithSubCategories;
    }
  }, {
    key: "removeDuplicatesFromArrayOfObjects",
    value: function removeDuplicatesFromArrayOfObjects(array, identifier) {
      return array.filter(function (el, idx, arr) {
        return idx === arr.findIndex(function (e) {
          return e[identifier] === el[identifier];
        });
      });
    }
  }, {
    key: "processActiveCategoryChange",
    value: function processActiveCategoryChange() {
      var _this$activeCategory,
          _this4 = this;

      if (this.isFilteringActive) {
        this.clearFilters();
      }

      if (!((_this$activeCategory = this.activeCategory) !== null && _this$activeCategory !== void 0 && _this$activeCategory.hasSubCategories)) {
        this.wineResults = this.winesObjectForUI[this.activeCategory.code];
        this.currentWinesForFilters = this.winesObjectForUI[this.activeCategory.code];
        this.subCategoriesList = [];
      } else {
        var currentCategoryObject = this.winesObjectForUI[this.activeCategory.code];
        this.currentWinesForFilters = this.getWinesForCategoryWithSubCategories(currentCategoryObject, this.activeCategory.code);
        var subCategories = Object.keys(currentCategoryObject);
        var currentCategory = this.activeCategory.code;
        this.subCategoriesList = subCategories.map(function (subCat) {
          var subCatValue = currentCategory === "pairings" ? _this4.winePairingCodesAndNames[subCat] : subCat;
          return {
            value: subCatValue,
            key: subCat
          };
        });
        this.wineResults = this.currentWinesForFilters;
      }

      this.sortWines();
    }
  }, {
    key: "getWineSizeByBottleSize",
    value: function getWineSizeByBottleSize(size) {
      if (size > 750) {
        return WineListTypes.WineSize.LARGE_FORMAT;
      }

      if (size <= 375) {
        return WineListTypes.WineSize.HALF_BOTTLE;
      }

      return WineListTypes.WineSize.BOTTLE;
    }
  }, {
    key: "setupFiltersObject",
    value: function setupFiltersObject() {
      var _this5 = this;

      if (this.isFilteringActive) return;
      var computedFilters = {
        REGION: {},
        FLAVOR: {},
        PRICE: {
          MIN: 0,
          MAX: 0,
          MIN_LIMIT: Number.MAX_VALUE,
          MAX_LIMIT: 0
        },
        VINTAGE: {},
        SIZE: {},
        VARIETAL: {},
        PAIRINGS: {}
      };
      this.currentWinesForFilters.forEach(function (wine) {
        for (var filterName in computedFilters) {
          switch (filterName) {
            case WineListTypes.FilterNames.REGION:
              {
                if (wine.regionName) {
                  computedFilters.REGION[wine.regionName] = false;
                }

                break;
              }

            case WineListTypes.FilterNames.FLAVOR:
              {
                computedFilters.FLAVOR[wine.flavorName] = false;
                break;
              }

            case WineListTypes.FilterNames.PRICE:
              {
                var bottlePrice = wine.bottlePrice;

                if (computedFilters.PRICE.MIN_LIMIT > bottlePrice) {
                  computedFilters.PRICE.MIN_LIMIT = bottlePrice;
                  computedFilters.PRICE.MIN = bottlePrice;
                }

                if (computedFilters.PRICE.MAX_LIMIT < bottlePrice) {
                  computedFilters.PRICE.MAX_LIMIT = bottlePrice;
                  computedFilters.PRICE.MAX = bottlePrice;
                }

                break;
              }

            case WineListTypes.FilterNames.VINTAGE:
              {
                var vintageYear = wine.vintage.trim();
                computedFilters.VINTAGE[vintageYear] = false;
                break;
              }

            case WineListTypes.FilterNames.SIZE:
              {
                var wineSize = _this5.getWineSizeByBottleSize(wine.bottleSize);

                computedFilters.SIZE[wineSize] = false;
                break;
              }

            case WineListTypes.FilterNames.VARIETAL:
              {
                computedFilters.VARIETAL[wine.varietalName] = false;
                break;
              }

            case WineListTypes.FilterNames.PAIRINGS:
              {
                if (_this5.wineContainsWinePairings(wine)) {
                  var pairingCodes = wine.winePairingCodes.map(function (winePairing) {
                    return winePairing.winePairingCode;
                  });
                  pairingCodes.forEach(function (code) {
                    computedFilters.PAIRINGS[code] = false;
                  });
                }

                break;
              }
          }
        }
      });
      this.filters = computedFilters;
      this.currentFilters = computedFilters;
    }
  }, {
    key: "wineContainsWinePairings",
    value: function wineContainsWinePairings(wine) {
      return wine.winePairingCodes && wine.winePairingCodes.length > 0;
    }
  }, {
    key: "onFilterControlPress",
    value: function onFilterControlPress(filterOption, filterName, applyFilter, throughSubCategoryList) {
      if (throughSubCategoryList) {
        this.setupFiltersObject();
      }

      var updatedFilters = cloneDeep(this.currentFilters);
      var currentFilterName = filterName !== null && filterName !== void 0 ? filterName : this.activeFilterName;

      if (currentFilterName === WineListTypes.FilterNames.PRICE) {
        updatedFilters.PRICE.MIN = filterOption.min;
        updatedFilters.PRICE.MAX = filterOption.max;
      } else {
        updatedFilters[currentFilterName][filterOption] = !updatedFilters[currentFilterName][filterOption];
      }

      this.currentFilters = updatedFilters;

      if (applyFilter) {
        this.applyFilters();
      }
    }
  }, {
    key: "clearFilters",
    value: function clearFilters() {
      var updatedFilters = cloneDeep(this.filters);

      for (var category in updatedFilters) {
        var currentFilterOptions = updatedFilters[category];

        if (category === WineListTypes.FilterNames.PRICE) {
          currentFilterOptions.MIN = this.filters.PRICE.MIN_LIMIT;
          currentFilterOptions.MAX = this.filters.PRICE.MAX_LIMIT;
        } else {
          for (var filterOption in updatedFilters[category]) {
            currentFilterOptions[filterOption] = false;
          }
        }
      }

      this.currentFilters = updatedFilters;
    }
  }, {
    key: "getActiveFilters",
    value: function getActiveFilters() {
      var filters = this.currentFilters;
      if (!filters) return null;
      var activeFiltersObject = {
        REGION: null,
        FLAVOR: null,
        VINTAGE: null,
        SIZE: null,
        PRICE: {
          min: null,
          max: null
        },
        VARIETAL: null,
        PAIRINGS: null
      };

      var _loop = function _loop() {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            filterName = _Object$entries$_i[0],
            filterOptions = _Object$entries$_i[1];

        if (filterName === WineListTypes.FilterNames.PRICE) {
          activeFiltersObject.PRICE.min = filterOptions.MIN;
          activeFiltersObject.PRICE.max = filterOptions.MAX;
        } else {
          activeFiltersObject[filterName] = Object.keys(filterOptions).filter(function (key) {
            return filterOptions[key] === true;
          });
        }
      };

      for (var _i = 0, _Object$entries = Object.entries(filters); _i < _Object$entries.length; _i++) {
        _loop();
      }

      return activeFiltersObject;
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      var _this6 = this;

      var activeFilters = this.getActiveFilters();
      var wines = this.currentWinesForFilters;
      var pairingFilterActive = this.isPairingFilterActive(activeFilters);
      var varietyFilterActive = this.isVarietyFilterActive(activeFilters);
      var flavorFilterActive = this.isFlavorFilterActive(activeFilters);
      var regionFilterActive = this.isRegionFilterActive(activeFilters);
      var vintageFilterActive = this.isVintageFilterActive(activeFilters);
      var sizeFilterActive = this.isWineSizeFilterActive(activeFilters);
      var priceFilterActive = this.isPriceFilterActive(activeFilters);
      var updatedWines = wines.filter(function (wine) {
        var flavorSatisfied = flavorFilterActive ? _this6.isWineSatisfyingFlavorFilter(wine, activeFilters) : true;
        var regionSatisfied = regionFilterActive ? _this6.isWineSatisfyingRegionFilter(wine, activeFilters) : true;
        var vintageSatisfied = vintageFilterActive ? _this6.isWineSatisfyingVintageFilter(wine, activeFilters) : true;
        var sizeSatisfied = sizeFilterActive ? _this6.isWineSatisfyingWineSizeFilter(wine, activeFilters) : true;
        var varietySatisfied = varietyFilterActive ? _this6.isWineSatisfyingVarietyFilter(wine, activeFilters) : true;
        var priceSatisfied = priceFilterActive ? _this6.isWineSatisfyingPriceFilter(wine, activeFilters) : true;
        var winePairingSatisfied = pairingFilterActive ? _this6.isWineSatisfyingWinePairingsFilter(wine, activeFilters) : true;
        return flavorSatisfied && regionSatisfied && vintageSatisfied && sizeSatisfied && priceSatisfied && varietySatisfied && winePairingSatisfied;
      });
      this.wineResults = updatedWines;
      this.filters = this.currentFilters;
      this.sortWines();
    }
  }, {
    key: "isFlavorFilterActive",
    value: function isFlavorFilterActive(activeFilters) {
      return activeFilters.FLAVOR.length !== 0;
    }
  }, {
    key: "isRegionFilterActive",
    value: function isRegionFilterActive(activeFilters) {
      return activeFilters.REGION.length !== 0;
    }
  }, {
    key: "isVintageFilterActive",
    value: function isVintageFilterActive(activeFilters) {
      return activeFilters.VINTAGE.length !== 0;
    }
  }, {
    key: "isWineSizeFilterActive",
    value: function isWineSizeFilterActive(activeFilters) {
      return activeFilters.SIZE.length !== 0;
    }
  }, {
    key: "isVarietyFilterActive",
    value: function isVarietyFilterActive(activeFilters) {
      return activeFilters.VARIETAL.length !== 0;
    }
  }, {
    key: "isPairingFilterActive",
    value: function isPairingFilterActive(activeFilters) {
      return activeFilters.PAIRINGS.length !== 0;
    }
  }, {
    key: "isPriceFilterActive",
    value: function isPriceFilterActive(activeFilters) {
      return activeFilters.PRICE.max !== this.filters.PRICE.MAX_LIMIT || activeFilters.PRICE.min !== this.filters.PRICE.MIN_LIMIT;
    }
  }, {
    key: "isWineSatisfyingFlavorFilter",
    value: function isWineSatisfyingFlavorFilter(wine, activeFilters) {
      return activeFilters.FLAVOR.includes(wine.flavorName);
    }
  }, {
    key: "isWineSatisfyingRegionFilter",
    value: function isWineSatisfyingRegionFilter(wine, activeFilters) {
      return activeFilters.REGION.includes(wine.regionName);
    }
  }, {
    key: "isWineSatisfyingVintageFilter",
    value: function isWineSatisfyingVintageFilter(wine, activeFilters) {
      return activeFilters.VINTAGE.includes(wine.vintage);
    }
  }, {
    key: "isWineSatisfyingWineSizeFilter",
    value: function isWineSatisfyingWineSizeFilter(wine, activeFilters) {
      var wineSize = this.getWineSizeByBottleSize(wine.bottleSize);
      return activeFilters.SIZE.includes(wineSize);
    }
  }, {
    key: "isWineSatisfyingVarietyFilter",
    value: function isWineSatisfyingVarietyFilter(wine, activeFilters) {
      return activeFilters.VARIETAL.includes(wine.varietalName);
    }
  }, {
    key: "isWineSatisfyingPriceFilter",
    value: function isWineSatisfyingPriceFilter(wine, activeFilters) {
      return wine.bottlePrice <= activeFilters.PRICE.max && wine.bottlePrice >= activeFilters.PRICE.min;
    }
  }, {
    key: "isWineSatisfyingWinePairingsFilter",
    value: function isWineSatisfyingWinePairingsFilter(wine, activeFilters) {
      var _wine$winePairingCode;

      var selectedPairingCode = activeFilters.PAIRINGS[0];
      if (!this.wineContainsWinePairings) return false;
      return wine === null || wine === void 0 ? void 0 : (_wine$winePairingCode = wine.winePairingCodes) === null || _wine$winePairingCode === void 0 ? void 0 : _wine$winePairingCode.some(function (code) {
        return code.winePairingCode === selectedPairingCode;
      });
    }
  }, {
    key: "sortWines",
    value: function sortWines() {
      var winesToBeSorted = this.isSearchActive ? this.searchResults : this.wineResults;
      if (!this.sortBy || !winesToBeSorted) return;
      var sortedWines = null;

      switch (this.sortBy) {
        case "Country":
          {
            sortedWines = sortBy(winesToBeSorted, "countryName");
            break;
          }

        case "Price":
          {
            sortedWines = sortBy(winesToBeSorted, "bottlePrice");
            break;
          }

        case "Region":
          {
            sortedWines = sortBy(winesToBeSorted, "regionName");
            break;
          }

        case "Vintage":
          {
            sortedWines = sortBy(winesToBeSorted, "vintage");
            break;
          }

        case "Bottle Size":
          {
            sortedWines = sortBy(winesToBeSorted, "bottleSize");
            break;
          }

        case "Varietal":
          {
            sortedWines = sortBy(winesToBeSorted, "varietalName");
            break;
          }

        default:
          sortedWines = sortBy(winesToBeSorted, "name");
          break;
      }

      if (this.isSearchActive && sortedWines) {
        this.searchResults = sortedWines;
      } else {
        this.wineResults = sortedWines;
      }
    }
  }, {
    key: "winesObjectForUI",
    get: function get() {
      return this._winesObjectForUI;
    },
    set: function set(winesObject) {
      var _this7 = this;

      runInAction(function () {
        _this7._winesObjectForUI = winesObject;
      });
    }
  }, {
    key: "categories",
    get: function get() {
      return this._decodeCategories();
    }
  }, {
    key: "activeCategory",
    get: function get() {
      return this._activeCategory;
    },
    set: function set(category) {
      var _this8 = this;

      runInAction(function () {
        _this8._activeCategory = category;
      });
    }
  }, {
    key: "winesList",
    get: function get() {
      return this._winesList;
    },
    set: function set(response) {
      var _this9 = this;

      runInAction(function () {
        _this9._winesList = response;
      });
    }
  }, {
    key: "searchText",
    get: function get() {
      return this._searchText;
    },
    set: function set(searchText) {
      var _searchText$normalize,
          _this10 = this;

      var normalisedText = searchText === null || searchText === void 0 ? void 0 : (_searchText$normalize = searchText.normalize("NFD")) === null || _searchText$normalize === void 0 ? void 0 : _searchText$normalize.replace(/(?:[\^`\xA8\xAF\xB4\xB7\xB8\u02B0-\u034E\u0350-\u0357\u035D-\u0362\u0374\u0375\u037A\u0384\u0385\u0483-\u0487\u0559\u0591-\u05A1\u05A3-\u05BD\u05BF\u05C1\u05C2\u05C4\u064B-\u0652\u0657\u0658\u06DF\u06E0\u06E5\u06E6\u06EA-\u06EC\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F5\u0818\u0819\u08E3-\u08FE\u093C\u094D\u0951-\u0954\u0971\u09BC\u09CD\u0A3C\u0A4D\u0ABC\u0ACD\u0AFD-\u0AFF\u0B3C\u0B4D\u0B55\u0BCD\u0C4D\u0CBC\u0CCD\u0D3B\u0D3C\u0D4D\u0DCA\u0E47-\u0E4C\u0E4E\u0EBA\u0EC8-\u0ECC\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F82-\u0F84\u0F86\u0F87\u0FC6\u1037\u1039\u103A\u1063\u1064\u1069-\u106D\u1087-\u108D\u108F\u109A\u109B\u135D-\u135F\u17C9-\u17D3\u17DD\u1939-\u193B\u1A75-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B34\u1B44\u1B6B-\u1B73\u1BAA\u1BAB\u1C36\u1C37\u1C78-\u1C7D\u1CD0-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1D2C-\u1D6A\u1DC4-\u1DCF\u1DF5-\u1DF9\u1DFD-\u1DFF\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2CEF-\u2CF1\u2E2F\u302A-\u302F\u3099-\u309C\u30FC\uA66F\uA67C\uA67D\uA67F\uA69C\uA69D\uA6F0\uA6F1\uA700-\uA721\uA788-\uA78A\uA7F8\uA7F9\uA8C4\uA8E0-\uA8F1\uA92B-\uA92E\uA953\uA9B3\uA9C0\uA9E5\uAA7B-\uAA7D\uAABF-\uAAC2\uAAF6\uAB5B-\uAB5F\uAB69-\uAB6B\uABEC\uABED\uFB1E\uFE20-\uFE2F\uFF3E\uFF40\uFF70\uFF9E\uFF9F\uFFE3]|\uD800\uDEE0|\uD802[\uDEE5\uDEE6]|\uD803[\uDD22-\uDD27\uDF46-\uDF50]|\uD804[\uDCB9\uDCBA\uDD33\uDD34\uDD73\uDDC0\uDDCA-\uDDCC\uDE35\uDE36\uDEE9\uDEEA\uDF3C\uDF4D\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC42\uDC46\uDCC2\uDCC3\uDDBF\uDDC0\uDE3F\uDEB6\uDEB7\uDF2B]|\uD806[\uDC39\uDC3A\uDD3D\uDD3E\uDD43\uDDE0\uDE34\uDE47\uDE99]|\uD807[\uDC3F\uDD42\uDD44\uDD45\uDD97]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF8F-\uDF9F\uDFF0\uDFF1]|\uD834[\uDD67-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD]|\uD838[\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD46\uDD48-\uDD4A])/g, "");
      runInAction(function () {
        _this10._searchText = normalisedText;
      });
    }
  }, {
    key: "subCategoriesList",
    get: function get() {
      return this._subCategoriesList;
    },
    set: function set(subCategoriesList) {
      var _this11 = this;

      runInAction(function () {
        _this11._subCategoriesList = subCategoriesList;
      });
    }
  }, {
    key: "filters",
    get: function get() {
      return this._filters;
    },
    set: function set(filters) {
      var _this12 = this;

      runInAction(function () {
        _this12._filters = filters;
      });
    }
  }, {
    key: "activeFilterName",
    get: function get() {
      return this._activeFilterName;
    },
    set: function set(FilterName) {
      var _this13 = this;

      runInAction(function () {
        _this13._activeFilterName = FilterName;
      });
    }
  }, {
    key: "currentFilters",
    get: function get() {
      return this._currentFilters;
    },
    set: function set(filters) {
      var _this14 = this;

      runInAction(function () {
        _this14._currentFilters = filters;
      });
    }
  }, {
    key: "winePairingCodesAndNames",
    get: function get() {
      return this._winePairingCodesAndNames;
    },
    set: function set(_winePairingCodesAndNames) {
      var _this15 = this;

      runInAction(function () {
        _this15._winePairingCodesAndNames = _winePairingCodesAndNames;
      });
    }
  }, {
    key: "wineResults",
    get: function get() {
      return this._wineResults;
    },
    set: function set(wines) {
      var _this16 = this;

      runInAction(function () {
        _this16._wineResults = wines;
      });
    }
  }, {
    key: "searchResults",
    get: function get() {
      return this._searchResults;
    },
    set: function set(wines) {
      var _this17 = this;

      runInAction(function () {
        _this17._searchResults = wines;
      });
    }
  }, {
    key: "restaurantNumber",
    get: function get() {
      return this._restaurantNumber;
    },
    set: function set(restaurantNumber) {
      var _this18 = this;

      runInAction(function () {
        _this18._restaurantNumber = restaurantNumber;
      });
    }
  }, {
    key: "displayWines",
    get: function get() {
      var _this$searchText2, _this$activeCategory2;

      if (((_this$searchText2 = this.searchText) === null || _this$searchText2 === void 0 ? void 0 : _this$searchText2.length) > 2 || !((_this$activeCategory2 = this.activeCategory) !== null && _this$activeCategory2 !== void 0 && _this$activeCategory2.hasSubCategories) || this.isFilteringActive) return true;
      return false;
    }
  }, {
    key: "loading",
    get: function get() {
      return this._loading;
    },
    set: function set(loading) {
      var _this19 = this;

      runInAction(function () {
        _this19._loading = loading;
      });
    }
  }, {
    key: "currentWinesForFilters",
    get: function get() {
      return this._currentWinesForFilters;
    },
    set: function set(wines) {
      var _this20 = this;

      runInAction(function () {
        _this20._currentWinesForFilters = wines;
      });
    }
  }, {
    key: "sortBy",
    get: function get() {
      return this._sortBy;
    },
    set: function set(sortOption) {
      var _this21 = this;

      runInAction(function () {
        _this21._sortBy = sortOption;
      });
    }
  }, {
    key: "isFilteringActive",
    get: function get() {
      var activeFilters = this.getActiveFilters();
      if (!activeFilters) return false;

      if (activeFilters.FLAVOR.length === 0 && activeFilters.REGION.length === 0 && activeFilters.VINTAGE.length === 0 && activeFilters.SIZE.length === 0 && activeFilters.VARIETAL.length === 0 && activeFilters.PAIRINGS.length === 0 && activeFilters.PRICE.min === this.filters.PRICE.MIN_LIMIT && activeFilters.PRICE.max === this.filters.PRICE.MAX_LIMIT) {
        return false;
      }

      return true;
    }
  }, {
    key: "isSearchActive",
    get: function get() {
      var _this$searchText3;

      return ((_this$searchText3 = this.searchText) === null || _this$searchText3 === void 0 ? void 0 : _this$searchText3.length) > 2;
    }
  }, {
    key: "filterCategories",
    get: function get() {
      var filters = Object.keys(WineListTypes.FilterNames).filter(function (category) {
        return category !== WineListTypes.FilterNames.VARIETAL && category !== WineListTypes.FilterNames.PAIRINGS;
      });
      var filtersAndSort = [].concat(_toConsumableArray(filters), ["Sort By"]);
      return filtersAndSort;
    }
  }]);

  return WineListModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_winesObjectForUI", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_activeCategory", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_winesList", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_searchText", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_loading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_subCategoriesList", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_wineResults", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_searchResults", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_filters", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_currentWinesForFilters", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_activeFilterName", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return WineListTypes.FilterNames.REGION;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_currentFilters", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_winePairingCodesAndNames", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_sortBy", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_restaurantNumber", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "winesObjectForUI", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "winesObjectForUI"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "categories", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "categories"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeCategory", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeCategory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "winesList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "winesList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchText", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "subCategoriesList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "subCategoriesList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filters", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "filters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activeFilterName", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "activeFilterName"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentFilters", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "winePairingCodesAndNames", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "winePairingCodesAndNames"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wineResults", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "wineResults"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchResults", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchResults"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantNumber", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayWines", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayWines"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "loading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentWinesForFilters", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentWinesForFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sortBy", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sortBy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFilteringActive", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFilteringActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSearchActive", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSearchActive"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filterCategories", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "filterCategories"), _class.prototype)), _class);